import * as React from 'react';
import styles from './tile-field.scss';
import { Link } from 'react-router';

interface TileFieldProps {
  className?: string;
  tooltip: string;
  label?: string;
  value: string;
  iconUrl?: string;
  bgColour?: string;
  bgColourDark?: boolean;
  onClick?: () => void;
  url?: string;
}

export const TileField = (props: TileFieldProps) => {

  const className = styles.tileValue
    + ' ' + ((props.onClick || props.url) ? styles.tileWithDrilldown : styles.tileNoDrilldown)
    + (props.bgColour ? ' ' + styles.tileColorbox : '')
    + (props.bgColourDark ? ' ' + styles.tileDarkBackground : '');

  const style = props.bgColour ? { backgroundColor: props.bgColour } : undefined;

  const value = props.url ?
    <Link tabIndex={0} to={props.url}>{props.value}</Link> :
    props.value;

  return <div title={props.tooltip}
    className={props.className}
    onClick={props.onClick}>
    {!!props.label && <p className={styles.tileLabel}>{props.label}</p>}
    <p className={className} style={style}>
      {!props.bgColour && !!props.iconUrl && <img src={props.iconUrl} />}
      {value}
    </p>
  </div>;
};
